import type { WaitlistQuestionnaire } from '@/types';
import { Badge } from '@/components/ui/badge';
import { getWaitlistQuestionnaireDisplay } from '../waitlistQuestionnaire';

interface WaitlistQuestionnaireViewProps {
  questionnaire?: WaitlistQuestionnaire | null;
  rawReason?: string;
  compact?: boolean;
}

function Section({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div className="space-y-1.5">
      <div className="text-xs font-medium text-muted-foreground">{label}</div>
      <div>{children}</div>
    </div>
  );
}

function LegacyReason({ rawReason }: { rawReason?: string }) {
  return (
    <Section label="原始申请内容">
      <div className="rounded-md border border-border bg-slate-50 p-3 text-sm leading-6 text-slate-700 whitespace-pre-wrap break-all">
        {rawReason?.trim() || '-'}
      </div>
    </Section>
  );
}

export function WaitlistQuestionnaireView({
  questionnaire,
  rawReason,
  compact = false,
}: WaitlistQuestionnaireViewProps) {
  const display = getWaitlistQuestionnaireDisplay(questionnaire);

  if (!display) {
    return <LegacyReason rawReason={rawReason} />;
  }

  return (
    <div className={compact ? 'space-y-3' : 'space-y-4'}>
      <Section label="使用目的">
        <div className="flex flex-wrap gap-1.5">
          {display.useCases.length > 0 ? (
            display.useCases.map((item) => (
              <Badge key={item} variant="outline" className="text-xs">
                {item}
              </Badge>
            ))
          ) : (
            <span className="text-sm text-muted-foreground">-</span>
          )}
        </div>
      </Section>

      <Section label="用户身份">
        <div className="flex flex-wrap gap-1.5">
          {display.roles.length > 0 ? (
            display.roles.map((item) => (
              <Badge key={item} variant="outline" className="text-xs">
                {item}
              </Badge>
            ))
          ) : (
            <span className="text-sm text-muted-foreground">-</span>
          )}
        </div>
      </Section>

      <Section label="社媒账号">
        <div className="text-sm text-foreground">
          {display.social || <span className="text-muted-foreground">-</span>}
        </div>
      </Section>

      <Section label="团队规模">
        <div className="text-sm text-foreground">
          {display.teamSize || <span className="text-muted-foreground">-</span>}
        </div>
      </Section>
    </div>
  );
}
